import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import React from 'react'
import { useParams } from 'react-router-dom'
import apiService from 'services/api'
import { getIdWithPrefix } from 'utils/pathUtils'
import CommonPage from 'components/DataExpansionComponents/Common/CommonPage'
import { ConvenienceDoorTable } from 'components/DataExpansionComponents/GooglePlaces/ConvenienceDoors/ConvenienceDoorsTable/ConvenienceDoorsTable'
import { CONVENIENCE_DOOR_TABLE_KEY } from 'constants/tableQueryKeys'
import { featureFlagService } from 'utils/featureFlagService'
import LoadingScreen from 'components/Layout/LoadingScreen'
import { NewConveniencePage } from '../new-company-pages/NewConveniencePage'

export default function ConveniencePage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const convenienceID = urlParams?.convenience_id
    ? getIdWithPrefix(
        urlParams?.convenience_id,
        preferences?.company_type_prefix_map[ContactCompanyType.Convenience]
      )
    : undefined

  const { enableNewCompanyPage, isLoading: isLoadingFF } = featureFlagService()

  if (isLoadingFF) {
    return <LoadingScreen />
  }

  if (enableNewCompanyPage) {
    return <NewConveniencePage convenienceID={convenienceID} />
  }

  const api = apiService()
  const { data, isLoading, isError, error } =
    api.useGetConvenience(convenienceID)

  return (
    <CommonPage
      uniqueCompanyTypeId={convenienceID}
      useGetCompany={{
        companyData: data,
        contactCompanyData: data,
        isLoading,
        isError,
        error,
      }}
      tableTypeSlug="convenience"
      companyTypeSlug="convenience"
      breadcrumbs={[
        {
          title: 'Convenience Stores',
          breadcrumb: data?.cstore?.name,
        },
      ]}
      getFieldsFromData={(data) => ({
        contactCompanyId: data?.id,
        companyName: data?.cstore?.name,
        websiteAddress: data?.cstore?.domain,
      })}
      doorSectionConfig={
        data
          ? {
              type: 'tabbed',
              forChainProxyId: data.id,
              chainData: {
                id: data.id,
                name: data.cstore?.name,
                domain: data.cstore?.domain,
                count: data.cstore?.doors_cnt,
              },
              subCategory: {
                name: 'Convenience',
                slug: 'convenience',
                description: 'Convenience',
              },
              matchedTableComponent: ConvenienceDoorTable,
              matchedTableKey: `${CONVENIENCE_DOOR_TABLE_KEY}-${data.id}`,
              matchedTableProps: {
                hideCreateCompanyButton: true,
                baseFilters: { chain_proxy_id: data.id },
              },
              unmatchedTableKeyPrefix: 'unmatched-convenience-doors-table',
            }
          : undefined
      }
    />
  )
}
